import React from 'react';
import { ArrowRight, ArrowLeft } from 'lucide-react';
import { Button } from '../ui/button';

const MobileDetailsSummary = ({ 
  totalAmount, 
  onBack, 
  onContinue, 
  canContinue,
  isProcessing = false,
}) => {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 bg-white border-t-2 border-[#FF8C00] p-4 lg:hidden z-50 shadow-lg"
      data-testid="mobile-details-summary"
    >
      <div className="flex items-center justify-between gap-3">
        <Button
          variant="outline"
          size="sm"
          onClick={onBack}
          className="border-gray-300 text-gray-700 hover:bg-gray-100"
          disabled={isProcessing}
          data-testid="mobile-back-btn"
        >
          <ArrowLeft className="h-4 w-4" />
        </Button>

        <div className="flex-1 text-center">
          <p className="text-xs text-gray-500">Total</p>
          <p className="text-xl font-bold text-black font-display">€{totalAmount}</p>
        </div>

        <Button
          data-testid="mobile-proceed-btn"
          className="bg-[#FF8C00] text-white hover:bg-[#E67E00] h-12 px-4 text-sm font-semibold"
          onClick={onContinue}
          disabled={!canContinue || isProcessing}
        >
          {isProcessing ? '...' : 'Proceed'}
          <ArrowRight className="h-4 w-4 ml-1" />
        </Button>
      </div>
    </div>
  );
};

export default MobileDetailsSummary;
